export const CUSTOMER_LEVEL = {
  ROOT: 0,
  N1: 1,
  N2: 2,
} as const;

export type IVehicleTypeGroup<TKeys extends string = string> = {
  externalId: number;
  name: string;
  publicKey: string;
  vehicleTypeIds: Array<string>;
  i18nKey: TKeys;
  vehicleTypes: Array<{
    name: string;
    publicKey: string;
    externalId: number;
    i18nKey: TKeys;
  }>;
};
